import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const ProductCardSkeleton = () => {
  return (
    <Card className="overflow-hidden border border-border/50 shadow-card bg-card flex flex-col">
      <Skeleton className="aspect-square rounded-t-lg rounded-b-none" />
      <div className="p-4 space-y-2 flex-1 flex flex-col">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-3/4" />
        <div className="mt-auto pt-2">
          <Skeleton className="h-7 w-24 mb-2" />
          <Skeleton className="h-9 w-full" />
        </div>
      </div>
    </Card>
  );
};

export default ProductCardSkeleton;
